import React from "react";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailCompose from "../pages/Email/email-compose";

import Emailtemplatealert from "../pages/EmailTemplate/email-template-alert";
import Emailtemplatebasic from "../pages/EmailTemplate/email-template-basic";
import Emailtemplatebilling from "../pages/EmailTemplate/email-template-billing";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//  // Inner Authentication

// Dashboard
import Dashboard from "../pages/Dashboard/index";
// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";

// Maps


//Icons
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import TypiconsIcon from "../pages/Icons/IconTypicons";
import IconIon from "../pages/Icons/IconIon";
import ThemifyIcon from "../pages/Icons/IconThemify";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";

// Forms

//Ui

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesInvoice from "../pages/Utility/PagesInvoice";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import PagesGallery from "../pages/Utility/PagesGallery";
import PagesDirectory from "../pages/Utility/PagesDirectory";
import PagesProfile from "pages/Utility/pages-profile";
import Orders from "pages/WorkOrders/Orders";
import CreateOrder from "pages/WorkOrders/CreateOrder";
import DepartmentList from "pages/Departments/DepartmentList";
import CategorieList from "pages/Categories/CatagorieList";
import ShiftList from "pages/Shifts/ShiftList";
import TeamList from "pages/Teams/TeamList";
import TeamUnAvailabilityList from "pages/TeamUnAvailability/TeamUnAvailabilityList";
import CheckList from "pages/Checklists/CheckList";
// import WorkOrderItemList from "pages/WorkOrderItems/WorkOrderItemList";
import TeamDetails from "pages/Profile/TeamDetails";
import Notifications from "pages/Notification/Notifications";
import FeedBackList from "pages/Feedbacks/FeedBackList";
import CustomerList from "pages/Customers/CustomersList";
import CreateCustomer from "pages/Customers/CreateCustomer";
import PermissionList from "pages/Permissions/PermissionList";
import CustomerProfile from "pages/Profile/CustomerDetails";
import CustomerAddress from "pages/Profile/CustomerAddress";
import CreateRole from "pages/Roles/CreateRole";
import RoleList from "pages/Roles/RolesList";
import UserList from "pages/Users/UserList";
import CreateWorkOrder from "pages/WorksOrders/CreateWorkOrder";
import WorkOrderList from "pages/WorksOrders/WorkOrderList";
import HolidayList from "pages/Holidays/HolidayList";
import WorkOrderDetails from "pages/WorksOrders/WorkOrderDetails";
import EditWorkOrder from "pages/WorksOrders/EditWorkOrder";
import UserProfile from "pages/UserProfile/UserProfile";
import ChangePassword from "pages/UserProfile/ChangePassword";
import CustomCalendar from "../pages/Calendar/index";
import CancellationList from "pages/Cancellation/CancellationList";
import ExtentionsList from "pages/WorkOrderExtensions/ExtentionsList";
import { Navigate } from "react-router-dom";
import AddFeedBack from "pages/Feedbacks/AddFeedBack";
import SettingsList from "pages/settings/settingsList";
import WorkOrderReport from "pages/WorksOrders/WorkOrderReport";
import TeamPerformanceReport from "pages/Reports/TeamPerformanceReport";
import Otp from "pages/Authentication/Otp";
import BranchList from "pages/Branches/BranchList";
import CreateSiteSurvey from "pages/Sitesurvey/CreateSiteSurvey";
import EditSiteSurvey from "pages/Sitesurvey/EditSiteSurvey";
import SiteSurveyList from "pages/Sitesurvey/SiteSurveyList";
import SiteSurveyDetails from "pages/Sitesurvey/SiteSurveyDetails";
import SiteSurveyCancellationList from "pages/SiteSurveyCancellations/SiteSurveyCancellationList";
import SiteSurveyExtentionsList from "pages/SiteSurveyExtensions/SiteSurveyExtensionList";
import CustomerFeedBack from "pages/Feedbacks/CustomerFeedBack";
import UpcomingWorkOrderList from "pages/WorksOrders/UpcomingWorkOrderList";
import OnGoingWorkOrderList from "pages/WorksOrders/OnGoingWorkOrderList";
import PendingWorkOrderList from "pages/WorksOrders/PendingWorkOrderList";
import CompletedWorkOrderList from "pages/WorksOrders/CompletedWorkOrderList";
import Pages403 from "pages/Utility/pages-403";
import SebelUserList from "pages/sebelUsers/SebelUserList";
import ZoneList from "pages/Zones/ZoneList";
import AreaList from "pages/Areas/AreaList";
import SolutionList from "pages/Solutions/SolutionList";
import ReasonsMasterList from "pages/ReasonsMaster/ReasonsMasterList";

const userRoutes = [
  // { path: "/", component: <Navigate to="/dashboard" /> },
  { path: "/dashboard", component: <Dashboard /> },

  // //calendar
  { path: "/calendar", component: <CustomCalendar /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },

  // this route should be at the end of all other routes
  { path: "/catalogues", component: <Orders /> },
  { path: "/createCatalogue", component: <CreateOrder /> },
  { path: "/departments", component: <DepartmentList /> },
  { path: "/categories", component: <CategorieList /> },
  { path: "/shifts", component: <ShiftList /> },
  { path: "/teams", component: <TeamList /> },
  //  {path:'/teamUnAvailability',component:<TeamUnAvailabilityList />},
  //  {path:"/checklists",component:<CheckList />},
  //  {path:"/workorderitems",component:<WorkOrderItemList />},
  { path: "/teamdetails/:id", component: <TeamDetails /> },
  { path: "/notifications", component: <Notifications /> },
  { path: "/feedbacks", component: <FeedBackList /> },
  { path: "/customerFeedBacks", component: <CustomerFeedBack /> },
  { path: "/customers", component: <CustomerList /> },
  { path: "/createCustomer", component: <CreateCustomer /> },
  { path: "/permissions", component: <PermissionList /> },
  { path: "/customerProfile/:id", component: <CustomerProfile /> },
  { path: "/customerAddress/:id", component: <CustomerAddress /> },
  { path: "/roles", component: <RoleList /> },
  { path: "/createRole", component: <CreateRole /> },
  { path: "/users", component: <UserList /> },
  { path: "/createWorkOrder", component: <CreateWorkOrder /> },
  { path: "/editWorkOrder/:id", component: <EditWorkOrder /> },
  { path: "/workorders", component: <WorkOrderList /> },
  { path: "/workOrderDetails/:id", component: <WorkOrderDetails /> },
  { path: "/holidays", component: <HolidayList /> },
  { path: "/profile/:id", component: <UserProfile /> },
  { path: "/changePassword", component: <ChangePassword /> },
  { path: "/workOrderCancellations", component: <CancellationList /> },
  { path: "/workOrderExtentions", component: <ExtentionsList /> },
  { path: "/settings", component: <SettingsList /> },
  { path: "/workOrderReport", component: <WorkOrderReport /> },
  { path: "/performanceReport", component: <TeamPerformanceReport /> },
  { path: "/branches", component: <BranchList /> },
  { path: "/createSiteSurvey", component: <CreateSiteSurvey /> },
  { path: "/editSiteSurvey/:id", component: <EditSiteSurvey /> },
  { path: "/sitesurveys", component: <SiteSurveyList /> },
  { path: "/SiteSurveyDetails/:id", component: <SiteSurveyDetails /> },
  { path: "/SiteSurveyCancellations", component: <SiteSurveyCancellationList /> },
  { path: "/SiteSurveyExtensions", component: <SiteSurveyExtentionsList /> },
  { path: "/upcomingWorkOrders", component: <UpcomingWorkOrderList /> },
  { path: "/ongointWorkOrders", component: <OnGoingWorkOrderList /> },
  { path: "/pendingWorkOrders", component: <PendingWorkOrderList /> },
  { path: "/completedWorkOrders", component: <CompletedWorkOrderList /> },
  { path: "/sebelUsers", component: <SebelUserList /> },
  { path: "/zones", component: <ZoneList /> },
  { path: "/areas", component: <AreaList /> },
  { path: "/solutions", component: <SolutionList /> },
  //  {path:"/reasonsMaster", component:<ReasonsMasterList />}
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/otp/:id", component: <Otp /> },
  { path: "/addFeedback", component: <AddFeedBack /> },
  // { path: "/forgot-password", component: <ForgetPwd /> },
  // { path: "/register", component: <Register /> },
  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-403", component: <Pages403 /> },
  { path: "/pages-500", component: <Pages500 /> },

  //Authentication Inner

];

export { userRoutes, authRoutes };
